var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDefaultPic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Imagen / Avatar / User / Default / Enabled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Imagen-/-Avatar-/-User-/-Default-/-Enabled",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 L32,0 C49.673112,-3.24649801e-15 64,14.326888 64,32 L64,32 C64,49.673112 49.673112,64 32,64 L32,64 C14.326888,64 2.164332e-15,49.673112 0,32 L0,32 C-2.164332e-15,14.326888 14.326888,3.24649801e-15 32,0 Z",
    id: "Mask",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Usuario",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 0 0.0400016667 32 32 32 32 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.278,16.0417333 C29.278,23.4044 23.3073333,29.3750667 15.9446667,29.3750667 C8.582,29.3750667 2.61133333,23.4044 2.61133333,16.0417333 C2.61133333,8.67906667 8.582,2.7084 15.9446667,2.7084 C23.3073333,2.7084 29.278,8.67906667 29.278,16.0417333 Z M20.6673333,14.6666667 C21.5873333,14.6666667 22.334,13.92 22.334,13 C22.334,12.08 21.5873333,11.3333333 20.6673333,11.3333333 C19.746,11.3333333 19.0006667,12.08 19.0006667,13 C19.0006667,13.92 19.746,14.6666667 20.6673333,14.6666667 Z M16.0006667,20.6666667 C18.2086667,20.6666667 20.0006667,20.208 20.0006667,18 L12.0006667,18 C12.0006667,20.208 13.7913333,20.6666667 16.0006667,20.6666667 Z M9.66733333,13 C9.66733333,13.92 10.414,14.6666667 11.334,14.6666667 C12.2526667,14.6666667 13.0006667,13.92 13.0006667,13 C13.0006667,12.08 12.2526667,11.3333333 11.334,11.3333333 C10.414,11.3333333 9.66733333,12.08 9.66733333,13 Z",
    id: "Combined-Shape",
    fill: "#444444",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefaultPic);
export default __webpack_public_path__ + "static/media/user-default-pic.a4bf8cdd140599bd7a026f1a4f4d82f2.svg";
export { ForwardRef as ReactComponent };